import { P, Text } from '@mxenabled/mxui'

import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'

interface EmbeddedCardProps {
  title: string
  description: string
  callToAction: string
  instanceSlot?: React.ReactNode
  onCtaClick?: () => void
}

export const EmbeddedCard = ({
  title,
  description,
  callToAction,
  instanceSlot = undefined,
  onCtaClick = () => {},
}: EmbeddedCardProps) => {
  return (
    <Card sx={{ pt: 8, pr: 16, pb: 12, pl: 8, borderRadius: '8px' }}>
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          pt: 4,
          pl: 8,
        }}
      >
        <Text bold={true} variant="body1">
          {title}
        </Text>
      </Stack>

      <Stack
        sx={{
          gap: 16,
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Stack>
          <Stack sx={{ pt: 2, pl: 8, pb: 8 }}>
            <P sx={{ fontWeight: 400 }} variant="subtitle2">
              {description}
            </P>
          </Stack>
          <Stack sx={{ alignItems: 'flex-start' }}>
            <Button
              onClick={onCtaClick}
              sx={{
                p: 0,
                height: 24,
                px: 8,
                py: 8,
                fontWeight: 600,
                fontSize: 13,
                lineHeight: '16px',
              }}
              variant="text"
            >
              {callToAction}
            </Button>
          </Stack>
        </Stack>
        {instanceSlot}
      </Stack>
    </Card>
  )
}
